import styled from 'styled-components'

export const ChildrenText = styled.div`
  text-decoration: underline dotted;
  text-decoration-color: var(--sl-color-gray-6);
  text-underline-offset: var(--sl-space-1);
`

export const TooltipContainer = styled.div`
  .Tooltip__Icon {
    img,
    svg {
      max-width: unset;
      display: inline;
    }
  }
`

export const TooltipTrigger = styled.button`
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: inherit;
  text-align: inherit;
`

export const TooltipContent = styled.div<TooltipContentProps>`
  --color: #ffffff;
  --arrow-size: 10px;

  /* Safe area */
  padding: 0.5rem 0;
  width: max-content;
  position: relative;

  /* Unified shadow for box + arrow */
  filter: drop-shadow(0 8px 24px rgba(16, 24, 40, 0.16))
    drop-shadow(0 2px 6px rgba(16, 24, 40, 0.08));

  .title {
    margin-bottom: var(--sl-space-1);
    font-size: var(--sl-font-size-2);
    line-height: 1.125;
    font-weight: var(--sl-font-weight-bold);
    text-align: left;
  }

  .text {
    position: relative;
    z-index: 1;

    /* Layout */
    width: max-content;
    max-width: 320px;
    max-height: 100rem;
    padding: 0.75rem 1rem;

    /* Appearance */
    color: var(--sl-fg-base);
    background: var(--color);
    border: 1px solid #e0e0e0;
    border-radius: var(--sl-radius-2);

    /* Typography */
    font-size: var(--sl-font-size-1);
    line-height: 1.25;
    font-weight: var(--sl-font-weight-medium);
    text-align: left;
  }

  .arrow {
    position: absolute;
    width: var(--arrow-size);
    height: var(--arrow-size);
    background: var(--color);
    border: 1px solid #e0e0e0;
    z-index: 2;
    transform: rotate(45deg);
  }

  /* Arrow at bottom, pointing down (tooltip above trigger) */
  &[data-position-y='top'] {
    .arrow {
      bottom: 3px;
      border-top: none;
      border-left: none;
      border-radius: 0 0 0 2px;
    }
  }

  /* Arrow at top, pointing up (tooltip below trigger) */
  &[data-position-y='bottom'] {
    .arrow {
      top: 3px;
      border-bottom: none;
      border-right: none;
      border-radius: 0 2px 0 0;
    }
  }

  &[data-position-x='center'] {
    .arrow {
      left: 50%;
      margin-left: calc(var(--arrow-size) / -2);
    }
  }

  &[data-position-x='right'] {
    .arrow {
      left: 12px;
    }
  }

  &[data-position-x='left'] {
    .arrow {
      right: 12px;
    }
  }
`
